import ChangeOrderIcon from "Assets/Img/ChangeOrderIcon";
import Button from "../../../../Components/Common/Button/Button";

interface PublishBarProps {
  currentStep: number;
  totalSteps: number;
  currentLabel: string;
  nextLabel?: string;
  isLast: boolean;
  onBack: () => void;
  onNext: () => void;
  onSave: () => void;
  onPublish: () => void;
  isSaving?: boolean;
  isPublishing?: boolean;
}

const PublishBar = ({
  currentStep,
  totalSteps,
  currentLabel,
  nextLabel,
  isLast,
  onBack,
  onNext,
  onSave,
  onPublish,
  isSaving = false,
  isPublishing = false,
}: PublishBarProps) => {
  const busy = isSaving || isPublishing;
  return (
    <div className="craPublishBar">
      <p>
        Step {currentStep} of {totalSteps} - {currentLabel}
      </p>
      <div className="craPublishBar__actions">
        {currentStep > 1 ? (
          <Button className="btnSecondary" onClick={onBack} disabled={busy}>
            ← Back
          </Button>
        ) : null}
        <Button className="btnSecondary" onClick={onSave} disabled={busy}>
          {isSaving && <span className="btnSpinner" />}
          {isSaving ? "Saving" : "Save Draft"}
        </Button>
        {!isLast ? (
          <Button className="btnPrimary" onClick={onNext} disabled={busy}>
            {nextLabel}
          </Button>
        ) : (
          <Button className="btnPublish" onClick={onPublish} disabled={busy}>
            {isPublishing ? (
              <span className="btnSpinner" />
            ) : (
              <ChangeOrderIcon />
            )}
            {isPublishing ? "Publishing..." : "Publish to Lender"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PublishBar;
